export const CSS = {
	container: 'c-FormDesigner',
	content: 'c-FormDesigner__content',
	header: 'c-FormDesigner__header',
	headerMsg: 'c0FormDesigner__header-message',
	field: {
		container: 'c-FormDesigner__fields',
	},
	info: {
		container: 'c-FormDesigner__info',
	},
	isEditing: 'c-FormDesigner--is-editing',
	isReadOnly: 'c-FormDesigner--is-read-only',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'flex-direction': 'column',
		width: '100%',
		height: '100%',
	},
	[CSS.content]: {
		display: 'flex',
		overflow: 'hidden',
		flex: 1,
	},
	[CSS.header]: {
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
	},
	[CSS.headerMsg]: {
		display: 'inline-flex',
		alignItems: 'center',
	},
	[CSS.field.container]: {
		'flex-direction': 'column',
		'overflow-y': 'auto',
		width: '300px',
	},
	[CSS.info.container]: {
		flex: 1,
		'overflow-y': 'auto',
	},
};
